import { AuthService, BASE_URL, IPushNotification, IPushResponse, PushRequest, Store, convertPushResponseToNotification } from "@utils";
import { action, makeObservable, observable, runInAction } from "mobx";
import { Inject, Service } from "typedi";
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';

// Дополняем кривые типы для SockJS
interface SockJSType extends WebSocket {
  _transport: any;
}

@Service()
export class PushStore extends Store<IPushNotification> {

  @Inject(() => PushRequest)
  private pushRequest: PushRequest;

  constructor() {
    super();
    makeObservable(this);
  }

  @observable newPushsCount = 0;
  socket: SockJSType;
  stompClient: Stomp.Client; 

  @action getNewPushsCount = () => {
    this.newPushsCount = this.data.reduce((accum, cur) => accum + (this.isPushInactive(cur) ? 0 : 1), 0);
  };

  @action answerMeeting = (meetingId: string, consumerId: string, confirm: boolean, pushId: number) => {
    this.pushRequest.answerMeeting(meetingId, consumerId, confirm)
      .then(() => this.answerPush(pushId));
  };

  @action offerTime = (pushId: number, meetingId: string, userId: string, offeredTime: Date) => {
    return this.pushRequest.offerTime(meetingId, userId, offeredTime)
      .then(() => this.answerPush(pushId));
  };

  @action answerPush = (id: number) => {
    this.data = this.data.map((elem) => (elem.id === id ? { ...elem, isAnswered: true } : elem));
  };

  @action readPush = () => {
    this.getNewPushsCount();
    this.stompClient.send('/app/push/read', {}, 'readPush');
  };

  isPushInactive = (push: IPushNotification) => ((
    push.notificationEventType === 'CREATE_MEETING' && push.isAnswered || 
    push.notificationEventType !== 'CREATE_MEETING') && push.isViewed
  );

  @action connect = () => {
    this.socket = new SockJS(BASE_URL + '/ws-push') as SockJSType;
    this.stompClient = Stomp.over(this.socket);
    this.stompClient.debug = null;

    if (!this.stompClient.connected) {
      this.stompClient.connect({ "access-token": AuthService.getToken('accessToken') }, () => {
        const sessionId = /\/([^\/]+)\/websocket/.exec(this.socket._transport.url)[1];
                  
        // Начальное получение пушей, тут вернётся список
        this.stompClient.subscribe('/user/' + sessionId +'/topic/push/init', (messageOutput) => {
          this.data = (JSON.parse(messageOutput.body) as IPushResponse[]) 
            .map((elem: IPushResponse) => convertPushResponseToNotification(elem));
          this.getNewPushsCount();
        });

        // Получение НОВЫХ пушей, тут они будут по одному
        this.stompClient.subscribe('/user/' + AuthService.getUserId() + '/topic/push/new', (messageOutput) => {
          this.data.unshift(convertPushResponseToNotification(JSON.parse(messageOutput.body) as IPushResponse));
          this.newPushsCount++;
        });

        // Получение ОБНОВЛЕНИЯ пушей, тут они будут по одному
        this.stompClient.subscribe('/user/' + AuthService.getUserId() + '/topic/push/update', (messageOutput) => {
          this.updatePush(messageOutput);
        });
      });
    }
  };

  @action clearPushs = () => {
    this.data = [];
    this.newPushsCount = 0;
  };

  @action updatePush = (msgOutput: Stomp.Message) => {
    const push = convertPushResponseToNotification(JSON.parse(msgOutput.body) as IPushResponse);
    this.data = this.data.map((elem) => {
      let result = elem;
      if (elem.id === push.id) {
        result = push;
        this.isPushInactive(push) && !this.isPushInactive(elem) && this.newPushsCount--;
      } 
      return result;
    });
  }

  @action disconnect = () => {
    this.stompClient.disconnect(() => {});
  };
}
